// src/components/CustomToggle/CustomToggle.js
import React from "react";
import styles from "./CustomToggle.module.css";

/**
 * Reusable Toggle Component
 * @param {Array} options  - [{ label, value }] - supports 2 or more options
 * @param {string} value   - currently selected value
 * @param {Function} onChange - (value) => void
 * @param {string} className - optional extra class
 */
function CustomToggle({ options = [], value, onChange, className = "" }) {
  if (!options || options.length < 2) return null;

  return (
    <div className={`${styles.toggleWrapper} ${className}`}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`${styles.toggleBtn} ${
            value === opt.value ? styles.toggleBtnActive : ""
          }`}
          onClick={() => onChange && onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default CustomToggle;